import { useTranslation } from 'react-i18next';
import { facilityCards } from '@/mocks/facilitiesData';

const cardImages = [
  '/images/generated/tjba26_a01_table_setting_check_r2.jpg',
  '/images/generated/tjba26_b08_tea_pour_closeup.jpg',
  '/images/generated/tjba26_b09_coat_brushing_closeup.jpg',
  '/images/generated/tjba26_a04_coat_service_roleplay_r2.jpg',
  '/images/generated/tjba26_b11_entrance_bow_female.jpg',
  '/images/generated/facilities-card-06.jpg',
];

export default function FacilityCards() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-12">
          {String(t('facilities.cards.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('facilities.cards.title')}
          </h2>
          {String(t('facilities.cards.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
          {String(t('facilities.cards.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto mt-5">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {facilityCards.map((card, idx) => (
            <div
              key={idx}
              className="card-glow group bg-background-50 border border-background-200/60 overflow-hidden cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={cardImages[idx]}
                  alt={t(`facilities.cards.${idx}.imgAlt`, t(`facilities.cards.${idx}.title`))}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  style={idx === 1 ? { objectPosition: '50% 100%' } : idx === 4 ? { objectPosition: '50% 15%' } : undefined}
                  loading="lazy"
                />
                {card.status === 'preparing' && (
                  <span className="absolute top-3 right-3 px-2.5 py-1 bg-accent-500/90 text-primary-950 text-[12px] tracking-[0.08em] font-medium">
                    {t('facilities.cards.preparing')}
                  </span>
                )}
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-accent-500/10 rounded-full flex-shrink-0">
                    <i className={`${card.icon} text-accent-600 text-sm`}></i>
                  </div>
                  <h3 className="font-heading text-[16px] text-foreground-800 tracking-[0.05em] group-hover:text-accent-600 transition-colors">
                    {t(`facilities.cards.${idx}.title`)}
                  </h3>
                </div>
                <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                  {t(`facilities.cards.${idx}.description`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
